import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';

@Component({
    selector: 'app-yield-by-submit-to',
    templateUrl: './yield-by-submit-to.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class YieldBySubmitToComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Yield By Submit To',
      chartType: FinanceDashboardChartType.Bar,
      backGroundColor:  ['#134220'],
      borderColor: ['#134220'],
      label: 'Submit To',
      barPercentage: 0.5,
      categoryPercentage: 0.5
    };
  }
}
